import React from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"
import CommentScreen from "../comments/CommentScreen"
import { TextAsImage } from "./TextAsImage"
import { PostListItemExpandedStyles } from "./constants"
import { CopyPostUrlLink } from "./CopyPostUrlLink"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "./RelatedPosts"
import clsx from "clsx"
import styles from "./styles.module.css"
import PremiereHeader from "./PremiereHeader"
import { PostListItemParams } from "../../types/posts"

export const EditorialListItemExpanded: React.FC<PostListItemParams> = ({
  post,
  setIsExpanded,
}) => {
  const alteredContent = post.editorial_content.replace(
    /&lt;iframe.*?src="https:\/\/www\.youtube\.com\/embed\/([^"]+)".*?&gt;&lt;\/iframe&gt;/g,
    (match, videoId) => {
      // Replace the escaped iframe with the actual embed HTML
      return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>`
    },
  )

  return (
    <div className="grid grid-cols-12 py-1">
      <PremiereHeader post={post} size="large" />
      <div className={PostListItemExpandedStyles.contentDiv}>
        <>
          {post.cover_image_url_large ? (
            <img
              src={post.cover_image_url_large}
              alt={post.title}
              onClick={(e) => setIsExpanded(false)}
              className={clsx(
                styles.editorialHeaderImageExpanded,
                "cursor-pointer",
                "w-full",
              )}
            />
          ) : (
            <TextAsImage text={post.title} />
          )}
        </>
      </div>
      <div className={PostListItemExpandedStyles.metaDiv}>
        <div className="flex">
          <h2
            className={clsx(
              PostListItemExpandedStyles.header,
              post.title.length > 100
                ? PostListItemExpandedStyles.headerLong
                : PostListItemExpandedStyles.headerShort,
              "cursor-pointer pr-2",
              post.is_bn_premiere && styles.premiereTitle,
            )}
            onClick={(e) => setIsExpanded(false)}
          >
            {post.title}
          </h2>
          <CopyPostUrlLink nadaUrl={post.nada_url} renderMode="button" />
        </div>
        <div className={styles.subtitle}>{post.subtitle}</div>
        <Link
          className={PostListItemExpandedStyles.bandName}
          to={post.local_path}
        >
          {post.band_name}
        </Link>
        <h3 className={PostListItemExpandedStyles.postDate}>
          {SmartDateFormat({
            dateStr: post.published_at,
            includeTime: false,
          })}
        </h3>
        <div
          className={styles.editorialContent}
          dangerouslySetInnerHTML={{ __html: alteredContent }}
        ></div>
      </div>
      <div className={PostListItemExpandedStyles.commentsDiv}>
        <RelatedPosts postId={post.id} className="mb-4" />
        <ReactionBlock
          contentType="Post"
          contentId={post.id}
          postId={post.id}
        />
        <CommentScreen
          postId={post.id}
          headerText="The Peanut Gallery Says:"
          className="my-4"
        />
      </div>
    </div>
  )
}
